module.exports = __webpack_public_path__ + "img/ultraviolet.dcf5b212.svg";